import React from 'react';
import FieldMultiselect from "../multiselect";
import FieldMultiselect_Pill from "../components/pill";

type FieldMultiselectGlistViewProps = {
    field       : FieldMultiselect
    model       : any,
    module      : any   // in this case this is glist !
    onClick?    : onClick
};

export default function FieldMultiselect_GlistView(props:FieldMultiselectGlistViewProps) {

    const value     = _.get(props.model, props.field.fieldId, null)
    const valueOptions   = props.field._getOptions(value)

    if (!valueOptions) return false;

    // calculate number of items based on available width
    const availableWidth:number = props.module.columns.get(props.field.fieldId).width - 20 - 15// 2 x 10px padding 15 more
    const itemsToShow:number    = Math.floor(availableWidth / props.field.pillMaxWidth)
    const moreOptions : number = (itemsToShow < valueOptions.length) ? valueOptions.length - itemsToShow : 0

    return (
        <React.Fragment>
            {_.map(valueOptions, (option, key:number) => {
                if (key >= itemsToShow) return;
                return <FieldMultiselect_Pill key={option.value}
                                              className="m-r-4"
                                              style={{maxWidth: props.field.pillMaxWidth}}
                                              size="22"
                                              option={option}
                                              onClick={props.onClick}/>
            })}

            {(moreOptions > 0) && <div className="ui5-link-small">{"+{0}".f(moreOptions)}</div>}
        </React.Fragment>
    );

}
